module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_plan_included_03_black-3a2a65dfb75bb1e5c3e26b510c4945cf.png";